import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import facebookPixelPlugin from './analyticsPixelPlugin';
import isServer from '@Helpers/isServer';
import { hotjar } from 'react-hotjar';
import * as Sentry from '@sentry/nextjs';

interface AnalyticsProps {
  gtmContainerId?: string;
  pixelId?: string;
}

export const analytics = ({ gtmContainerId, pixelId }: AnalyticsProps) => {
  const analytics = Analytics({
    app: 'ActionFunder',
    plugins: [
      googleTagManager({
        containerId: gtmContainerId,
      }),
      facebookPixelPlugin({ pixelId }),
    ],
  });
  analytics.page();
};

export const recordDataLayerEvent = (event: string) => {
  if (!isServer && window.dataLayer) {
    try {
      window.dataLayer.push({
        event,
      });

      // Try to record Hotjar event separately
      try {
        hotjar.event(event);
      } catch (hotjarError) {
        Sentry.captureMessage('Hotjar event failed', {
          level: 'warning',
          extra: { error: hotjarError, event },
        });
      }
    } catch (error) {
      // Log error but don't stop the sign up flow
      Sentry.captureMessage('Analytics event failed', {
        level: 'warning',
        extra: { error, event },
      });
    }
  }
};
